import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from 'react-leaflet';
import { Modal, Button, Form } from 'react-bootstrap';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

function LocationSelector({ setLocation }) {
  useMapEvents({
    click(e) {
      setLocation(e.latlng);
    },
  });
  return null;
}

export default function ModalUbi( props) {
    const { ModalUbiacion,
		setModalUbiacion,
		Ubicacion,
		setUbicacion,
		RadioUbicacion,
		setRadioUbicacion,
		setLatitud,
		setLongitud, } = props;

    const setCoordenadas = (e) => {
		setUbicacion({lat: e.lat, lng: e.lng});
		setLatitud(e.lat);
		setLongitud(e.lng);
	};

  return (
    <>
      <Modal show={ModalUbiacion} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Selecciona ubicación y radio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MapContainer
            center={Ubicacion || [40.4168, -3.7038]} // Centro en Madrid
            zoom={10}
            style={{ height: '400px', width: '100%' }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; OpenStreetMap contributors"
            />
            <LocationSelector setLocation={setCoordenadas} />
            {Ubicacion && (
              <>
                <Marker position={Ubicacion} />
                <Circle center={Ubicacion} radius={RadioUbicacion} />
              </>
            )}
          </MapContainer>

          <div className='radio-de-actuacion-registro-empresas'>
            <div>
                Selecciona la ubicación de tu empresa haciendo clic en el mapa y
                a continuación indica el radio de actuación donde ofrecerás tus
                servicios a domicilio:
            </div>
            <p className='text-center'><strong>{' ' + RadioUbicacion / 1000 + ' km'}</strong></p>
            <div className='input-range-radio-de-actuacion-registro-empresas'>
                0km
                <input
                    type='range'
                    color='red'
                    value={RadioUbicacion}
                    onChange={(e) =>
                        setRadioUbicacion(parseInt(e.target.value))
                    }
                    min={500}
                    max={600000}
                    step={500}
                />
                600km
            </div>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn login-boton' onClick={() => setModalUbiacion(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}